import "./Policy.css";
import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <div className="policy-container">

      <h1>{t("privacy_policy")}</h1>

      <p>
        {t("policy.privacy.intro")}
      </p>

      <h2>{t("policy.privacy.section1.title")}</h2>

      <p>{t("policy.privacy.section1.desc")}</p>

      <ul>
        <li>{t("policy.privacy.section1.items.email")}</li>
        <li>{t("policy.privacy.section1.items.username")}</li>
        <li>{t("policy.privacy.section1.items.ip")}</li>
        <li>{t("policy.privacy.section1.items.browser")}</li>
        <li>{t("policy.privacy.section1.items.logs")}</li>
        <li>{t("policy.privacy.section1.items.files")}</li>
        <li>{t("policy.privacy.section1.items.name")}</li>
        <li>{t("policy.privacy.section1.items.phone")}</li>
        <li>{t("policy.privacy.section1.items.address")}</li>
        <li>{t("policy.privacy.section1.items.delivery_memo")}</li>
      </ul>

      <h2>{t("policy.privacy.section2.title")}</h2>

      <p>{t("policy.privacy.section2.desc")}</p>

      <ul>
        <li>{t("policy.privacy.section2.items.account")}</li>
        <li>{t("policy.privacy.section2.items.service")}</li>
        <li>{t("policy.privacy.section2.items.security")}</li>
        <li>{t("policy.privacy.section2.items.analytics")}</li>
        <li>{t("policy.privacy.section2.items.support")}</li>
        <li>{t("policy.privacy.section2.items.printing_order")}</li>
        <li>{t("policy.privacy.section2.items.estimate")}</li>
        <li>{t("policy.privacy.section2.items.notification")}</li>
      </ul>

      <h2>{t("policy.privacy.section3.title")}</h2>

      <p>
        {t("policy.privacy.section3.p1")}
      </p>

      <p>
        {t("policy.privacy.section3.p2")}
      </p>

      <h2>{t("policy.privacy.section4.title")}</h2>

      <p>{t("policy.privacy.section4.p1")}</p>
      <p>{t("policy.privacy.section4.p2")}</p>
      <p>{t("policy.privacy.section4.p3")}</p>
      <p>
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("policy.privacy.section4.link")}
        </a>
      </p>

      <h2>{t("policy.privacy.section5.title")}</h2>

      <p>
        {t("policy.privacy.section5.p1")}
      </p>

      <ul>
        <li>{t("policy.privacy.section5.items.google")}</li>
      </ul>

      <p>
        {t("policy.privacy.section5.p2")}
      </p>

      <h2>{t("policy.privacy.section6.title")}</h2>

      <p>
        {t("policy.privacy.section6.p1")}
      </p>

      <h2>{t("policy.privacy.section7.title")}</h2>

      <p>
        {t("policy.privacy.section7.p1")}
      </p>
      <p>
        {t("policy.privacy.section7.p2")}
      </p>

      <h2>{t("policy.privacy.section8.title")}</h2>

      <p>{t("policy.privacy.section8.desc")}</p>

      <ul>
        <li>{t("policy.privacy.section8.items.read")}</li>
        <li>{t("policy.privacy.section8.items.edit")}</li>
        <li>{t("policy.privacy.section8.items.delete")}</li>
      </ul>

      <h2>{t("policy.privacy.section9.title")}</h2>

      <p>
        {t("policy.privacy.section9.p1")}
      </p>

      <h2>{t("policy.privacy.section10.title")}</h2>

      <p>
        {t("policy.privacy.section10.p1")}
      </p>

      <h2>{t("policy.privacy.section11.title")}</h2>

      <p>{t("policy.privacy.section11.p1")}</p>
      <p>{t("policy.privacy.section11.company")}</p>
      <p>{t("policy.privacy.section11.email")}</p>

      <h2>{t("policy.privacy.section12.title")}</h2>

      <p>{t("policy.privacy.section12.p1")}</p>

    </div>
  );
}
